<!--
 * @Description  : 合同模板维护--新
 * @Author       : 钱磊
 * @Date         : 2022-08-31 09:52:20
 * @LastEditors  : 王帅
 * @LastEditTime : 2025-10-14 14:59:38
 * @FilePath     : \ngs_platform_manage_admin\src\views\operation-management\es-contract-template-maintain-new\index.vue
-->
<template>
	<div class="audit operation-layout h100" :class="{ pd0: !routeQuery }">
		<!-- 列表查询页 -->
		<filter-layout @search="doSearch" @reset="doRefresh" v-if="!routeQuery">
			<template #filter>
				<el-form class="flex-row-form colspan-4" size="small" ref="searchRef" :model="searchObj" label-width="110px">
					<el-form-item label="模板名称：" prop="sname">
						<el-input :placeholder="'请输入模板名称'" clearable v-model="searchObj.docTemplateName" size="small"></el-input>
					</el-form-item>
					<el-form-item label="模板ID：" prop="applyBus">
						<el-input :placeholder="'请输入模板ID'" clearable v-model="searchObj.id" size="small"></el-input>
					</el-form-item>
				</el-form>
			</template>
			<template #content>
				<!-- 非请求参数 正常查看 -->
				<div class="operation-main">
					<div class="operation-header">
						<div class="title">
							总共设置了<span class="blue">{{ searchObj.totalResult }}</span>
							项内容
						</div>
						<div class="btnGroups">
							<el-button class="btn-success" size="small" icon="el-icon-plus" @click="handleTools('add')">新增合同模板配置</el-button>
						</div>
					</div>
					<div class="operation-container w-table-layout w-table-page">
						<div class="w-table-content" v-show="tableShow">
							<vxe-table
								:data="tableObj.tableData"
								:loading="tableObj.loading"
								:border="tableObj.border"
								:resizable="tableObj.resizable"
								:size="tableObj.size"
								:height="tableObj.height"
								highlight-current-row
								highlight-hover-row
								show-overflow="tooltip"
								v-show="tableShow"
								show-header-overflow="tooltip"
							>
								<vxe-table-column type="seq" title="序号" align="center" width="70"></vxe-table-column>
								<vxe-table-column field="confId" title="配置ID" width="100" align="center" show-overflow-tooltip></vxe-table-column>
								<vxe-table-column field="docTemplateName" title="模板名称" align="center"> </vxe-table-column>
								<vxe-table-column field="docTemplateId" title="模板ID" align="center"></vxe-table-column>
								<vxe-table-column field="bizTypeName" title="应用业务" align="center" width="110"></vxe-table-column>
								<vxe-table-column field="bizSceneName" title="业务场景" align="center" width="150"></vxe-table-column>
								<vxe-table-column field="createDate" title="更新时间" align="center" width="150"> </vxe-table-column>
								<vxe-table-column title="状态" align="center" width="100">
									<template v-slot="{ row }">
										<vxe-switch
											v-model="row.isUsed"
											open-label="启用"
											:open-value="1"
											close-label="关闭"
											:close-value="0"
											@change="changeStatus(row)"
										></vxe-switch>
									</template>
								</vxe-table-column>
								<vxe-table-column title="操作" width="160" align="center">
									<template v-slot="{ row }">
										<el-button
											type="success"
											size="small"
											round
											plain
											class="table-btn"
											:disabled="row.ruleStatus == 1"
											@click="handleTools('edit', row)"
										>
											<svg-icon icon-class="form-edit"></svg-icon> 编辑
										</el-button>
										<el-button
											type="danger"
											size="small"
											round
											plain
											class="table-btn"
											icon="el-icon-delete"
											:disabled="row.ruleStatus == 1 || row.isUsed == '1'"
											@click="handleTools('delete', row)"
											>删除
										</el-button>
									</template>
								</vxe-table-column>
							</vxe-table>
						</div>
						<div class="w-table-footer">
							<vxe-pager
								size="mini"
								:current-page="searchObj.current"
								:page-size="searchObj.size"
								:total="searchObj.totalResult"
								class="text-center"
								:page-sizes="[10, 20, 50, 100]"
								:layouts="['Total', 'Sizes', 'PrevPage', 'JumpNumber', 'NextPage', 'FullJump']"
								@page-change="handlePageChange"
							>
							</vxe-pager>
						</div>
					</div>
				</div>
			</template>
		</filter-layout>

		<!-- 详情页 -->
		<template v-else>
			<edit-template v-if="routeQuery == 'template'" @close="doSearch"></edit-template>
			<add-template v-else @close="doSearch"></add-template>
		</template>
	</div>
</template>

<script>
import { mapState } from 'vuex'
import * as API from 'api/modules/es/es_template.js'
import AddTemplate from './components/add-template'
import EditTemplate from './components/edit-template'

export default {
	data() {
		return {
			showFilter: true,
			searchObj: {
				docTemplateName: '', // 模板名称
				id: '', // 模板ID
				current: 1, // 当前页码
				size: 10, // 当前每页条数
				totalResult: 0
			},
			// 表格对象
			tableObj: {
				tableData: [],
				loading: false,
				border: true,
				resizable: true,
				size: 'small',
				height: '100%'
			},
			searchToggle: true, //筛选控制
			tableShow: true //表格显隐控制
		}
	},
	components: {
		AddTemplate,
		EditTemplate
	},
	created() {
		if (this.isBack) {
			if (this.$getSessionItem('searchObj')) {
				this.searchObj = JSON.parse(this.$getSessionItem('searchObj'))
				// 移除 避免污染
				this.$removeSessionItem('searchObj')
			}
			if (this.$getSessionItem('templateId')) {
				// 移除 避免污染
				this.$removeSessionItem('templateId')
			}
			if (this.$getSessionItem('templateId')) {
				// 移除 避免污染
				this.$removeSessionItem('templateId')
			}
		}
		this.doSearch()
	},
	methods: {
		// 查询评价设置列表
		doSearch(page) {
			if (page) {
				this.searchObj.size = 10
				this.searchObj.current = 1
			}
			let params = Object.assign({}, this.searchObj)
			this.tableObj.loading = true
			API.getTemplateList(params)
				.then((res) => {
					this.tableObj.loading = false
					if (res.operationCode === 1) {
						this.tableObj.tableData = res.data.records
						this.searchObj.totalResult = parseInt(res.data.total)
					}
				})
				.catch((err) => {
					this.tableObj.loading = false
				})
		},
		//刷新/重置
		doRefresh() {
			this.searchObj.size = 10
			this.searchObj.current = 1
			this.searchObj.docTemplateName = ''
			this.searchObj.id = ''
			this.doSearch()
		},
		// 当启用状态发生变化时
		changeStatus(row) {
			this.tableObj.loading = true
			let _flag = row.isUsed
			row.isUsed = row.isUsed == 0 ? 1 : 0
			let params = Object.assign({}, row)
			params.isUsed = _flag
			API.saveOrUpdate(params).then((res) => {
				if (res.operationCode == 1) {
					setTimeout(() => {
						this.$message.success('设置成功！')
						this.doSearch()
					}, 1000)
				}
			})
		},
		// 右侧操作
		handleTools(type, row) {
			switch (type) {
				case 'delete':
					if (row.docTemplateCreateUrl == '') {
						this.$confirm('请确认是否要删除该合同模板?', '删除', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning'
						}).then(() => {
							this.tableObj.loading = true
							API.delTemp({ id: row.id }).then((res) => {
								this.$message.success('删除成功')
								setTimeout(() => {
									this.doSearch()
								}, 1000)
							})
						})
					} else {
						this.$alert('模板已上传E签宝，无法删除', '删除')
					}
					break
				case 'add':
					this.$router.push({
						path: '/es-contract-template-maintain-new',
						query: {
							type: 'add'
						}
					})
					break
				default:
					let rowId = row.id
					// 存值
					this.$setSessionItem('templateId', JSON.stringify(rowId))
					// 存值
					this.$setSessionItem('searchObj', JSON.stringify(this.searchObj))
					this.$router.push({
						path: '/es-contract-template-maintain-new',
						query: {
							type: 'edit'
						}
					})
			}
		},
		// 切换状态
		changeState() {
			this.searchToggle = !this.searchToggle
		},

		// 切换分页
		handlePageChange({ currentPage, pageSize }) {
			this.searchObj.current = currentPage
			this.searchObj.size = pageSize
			this.doSearch()
		}
	},
	computed: {
		routeQuery() {
			return this.$route.query.type
		},
		...mapState('app', { isBack: (state) => state.isBack }),
		...mapState('dict', {
			yyyw: (state) => state.yyyw
		})
	},
	watch: {
		// 监听 筛选元素的 切换展示 重新调整表格高度
		searchToggle() {
			this.tableShow = false
			setTimeout(() => {
				this.tableShow = true
			}, 50)
		}
	}
}
</script>

<style scoped>
.operation-layout.pd0 {
	padding: 0;
}
</style>
